import type { Occupation } from './globals'
import type { GenderEnum } from './person'

import type { User } from '#auth-utils'

export type Biometrics = Nullable<{
  height: string
  occupation: Occupation
  weight: number
  gender: PropsTypesOf<typeof GenderEnum>['code']
}>

export type BiometricHeight = { feet: number; inches: number }

function load(model?: Partial<Biometrics> | null, user?: User | null): Biometrics {
  return {
    height: model?.height ?? null,
    occupation: model?.occupation ?? null,
    weight: model?.weight ?? null,
    gender: model?.gender ?? user?.userData?.gender ?? null,
  }
}

const heightOptions = (max?: BiometricHeight, min?: BiometricHeight) => {
  const foot = { from: min?.feet ?? 0, to: max?.feet ?? 8 }
  const foots = Array(foot.to)
    .fill(foot.from)
    .map((x, i) => x + i)
  const inch = { from: min?.inches ?? 0, to: max?.inches ?? 12 }
  const inches = Array(inch.to)
    .fill(inch.from)
    .map((x, i) => x + i)
  return [
    ...foots.flatMap((foot) => inches.map((inch) => `${foot}' ${inch}"`)),
    `${foot.to}' ${inch.from}"`,
  ]
}

const map = {
  BiometricosViewModel(model: Biometrics): SiteApiSchema<'BiometricosViewModel'> {
    const biometrics: SiteApiSchema<'BiometricosViewModel'> = {}

    const heightInfo = model.height?.split("'")

    if (heightInfo != null && heightInfo.length == 2) {
      biometrics.estaturaPies = heightInfo[0]
      biometrics.estaturaPulgadas = heightInfo[1]?.replace('"', '')
    }

    biometrics.pesoEnLibras = model.weight?.toString()
    return biometrics
  },
}

export const Biometrics = {
  load,
  heightOptions,
  map,
}
